import { useSelector } from "react-redux";
import { Stack } from "@fluentui/react/lib/Stack";
import { Text } from "@fluentui/react/lib/Text";
import { TooltipHost } from "@fluentui/react/lib/Tooltip";

import { selectVersions } from "Store/Selectors/UI";
import Package from "../../../../package.json";
import { useSystemInformationStyles } from "./UseSystemInformationStyles";

export function SystemInformation(): JSX.Element {
  const versions = useSelector(selectVersions);
  const styles = useSystemInformationStyles();

  const content = (
    <Stack>
      <Stack.Item>{`UI: ${Package.version}`}</Stack.Item>
      <Stack.Item>{`Backend: ${versions[`backend-api`]}`}</Stack.Item>
      <Stack.Item>{`Storage: ${versions[`storage-api`]}`}</Stack.Item>
      <Stack.Item>{`DuplicateCheck: ${versions[`omikron-api`]}`}</Stack.Item>
      <Stack.Item>{`Target: ${versions[`target-api`]}`}</Stack.Item>
      <Stack.Item>{`DataProvider: ${versions[`gdp-api`]}`}</Stack.Item>
    </Stack>
  );

  return (
    <Stack className={styles.root}>
      <Stack.Item grow={false}>
        <TooltipHost content={content}>
          <Text>{`Version: ${Package.version}`}</Text>
        </TooltipHost>
      </Stack.Item>
    </Stack>
  );
}
